// @flow

import React from 'react';
import DualPriceTooltipDesktop from '../DualPriceTooltipDesktop/DualPriceTooltipDesktop';
import DualPriceTooltipMobile from '../DualPriceTooltipMobile/DualPriceTooltipMobile';
import PriceItem from '../PriceItem/PriceItem';

import type {IntlShape} from 'react-intl';
import type {PriceItemShape, PriceLabelShape} from '../DualPrice/DualPrice';

import './DualPriceTooltip.less';

const DualPriceTooltip = ({
    isDesktop,
    prices,
    priceLabel,
    isModalOpen,
    setModalOpen,
    showInstantBookIcon,
    instantBookable,
    intl
}: {
    isDesktop: boolean,
    prices: PriceItemShape[],
    priceLabel: PriceLabelShape,
    isModalOpen: boolean,
    setModalOpen: (isModalOpen: boolean) => void,
    showInstantBookIcon: boolean,
    instantBookable: boolean,
    intl: IntlShape
}) => {
    return isDesktop ? (
        // $FlowFixMe!
        prices.map((price, index) => {
            if (price.withTooltip) {
                return (
                    <DualPriceTooltipDesktop
                        key={`price_${index}`}
                        content={priceLabel.pricePeriodDescription}
                    >
                        {
                            <PriceItem
                                item={price}
                                key={`price_${index}`}
                                showInstantBookIcon={showInstantBookIcon}
                                instantBookable={instantBookable}
                                intl={intl}
                            />
                        }
                    </DualPriceTooltipDesktop>
                );
            }
            return (
                <PriceItem
                    item={price}
                    key={`price_${index}`}
                    showInstantBookIcon={showInstantBookIcon}
                    instantBookable={instantBookable}
                    intl={intl}
                />
            );
        })
    ) : (
        <DualPriceTooltipMobile
            content={priceLabel.pricePeriodDescription}
            isModalOpen={isModalOpen}
            setModalOpen={setModalOpen}
        >
            {prices.map((price, index) => (
                <PriceItem
                    item={price}
                    key={`price_${index}`}
                    showInstantBookIcon={showInstantBookIcon}
                    instantBookable={instantBookable}
                    intl={intl}
                />
            ))}
        </DualPriceTooltipMobile>
    );
};

export default DualPriceTooltip;
